/**
 * MODULE: domain/pages/frontend/hooks/useCrmEntityPreview.ts
 * PURPOSE: TanStack Query hooks for live CRM preview blocks
 */

import { useQuery } from '@tanstack/react-query';
import { pagesApi } from '../api/pagesApi';
import type { CrmPreviewEntityType } from '../utils/crmEntityPreviewUtils';

export const CRM_ENTITY_PREVIEW_KEY = (entityType: CrmPreviewEntityType, entityId: string) =>
  ['pages', 'crm-preview', entityType, entityId] as const;

export function useCrmEntityPreview(
  entityType: CrmPreviewEntityType,
  entityId: string | null | undefined,
  options?: { enabled?: boolean }
) {
  const id = entityId?.trim() ?? '';
  const enabled = options?.enabled !== false;
  return useQuery({
    queryKey: CRM_ENTITY_PREVIEW_KEY(entityType, id),
    queryFn: async () => {
      if (entityType === 'deal') return pagesApi.getCrmDealPreview(id);
      if (entityType === 'contact') return pagesApi.getCrmContactPreview(id);
      return pagesApi.getCrmCompanyPreview(id);
    },
    enabled: Boolean(id) && enabled,
    staleTime: 60_000,
  });
}

/** @deprecated Use useCrmEntityPreview('deal', dealId) */
export function useCrmDealPreview(dealId: string | null | undefined) {
  return useCrmEntityPreview('deal', dealId);
}
